import { MouseEventHandler } from 'react';
import { BaseSlide } from '../../../models/slides/BaseSlide';
import { ArrowButtons } from './ArrowButtons';
import { NavigationButtons } from './NavigationButtons';

interface CarouselButtonsProps {
  slides: BaseSlide[];
  currentIndex: number;
  prevSlide: MouseEventHandler<HTMLButtonElement>;
  nextSlide: () => void;
  handleDotClick: (index: number) => void;
  buttonColor: string;
  autoPlay: boolean;
  isHovered: boolean;
}

/**
 * CarouselButtons component
 * this component is responsible for rendering the arrow and dot buttons in the carousel
 * @param slides - slides array
 * @param currentIndex - current index of the slide
 * @param prevSlide - function to go to the previous slide
 * @param nextSlide - function to go to the next slide
 * @param handleDotClick - function to handle the dot click
 * @param buttonColor - color of the buttons
 * @param autoPlay - auto play state
 * @param isHovered - is hovered state
 * @returns CarouselButtons component
 */

export const CarouselButtons = ({ slides, currentIndex, prevSlide, nextSlide, handleDotClick, buttonColor, autoPlay, isHovered }: CarouselButtonsProps) => {
  // If there is zero or one slide, return
  if (slides?.length <= 1) return <></>;

  return (
    <div className='flex px-1 w-full min-[350px]:mt-2 min-[350px]:mb-1 md:mb-2 gap-2 justify-between'>
      <NavigationButtons currentIndex={currentIndex} handleDotClick={handleDotClick} slides={slides} buttonColor={buttonColor} autoPlay={autoPlay} isHovered={isHovered} />
      <ArrowButtons nextSlide={nextSlide} prevSlide={prevSlide} />
    </div>
  );
};
